// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { InvoiceSettlement } from '@/billing/api/types';
import { formatCurrencyValue } from '@/currency/utilities/format';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { DateTime } from 'luxon';

function formatDate(dt: DateTime): string {
  return dt.toLocaleString({
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

function formatTimestamp(dt: DateTime): string {
  return dt.toLocaleString(DateTime.DATETIME_MED);
}

export function SettlementRow(props: { settlement: InvoiceSettlement }) {
  const { settlement } = props;
  const chipLabel =
    settlement.sourceType === 'CREDIT_MEMO' ? 'Credit' : 'Payment';
  const reference =
    settlement.sourceType === 'CREDIT_MEMO'
      ? settlement.creditMemoNumber
      : settlement.paymentReference;
  const displayDate =
    settlement.sourceType === 'PAYMENT' && settlement.paymentDate
      ? formatDate(settlement.paymentDate)
      : formatTimestamp(settlement.appliedAt);

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <Box>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="body2" fontWeight="bold">
            {displayDate}
          </Typography>
          <Chip
            label={chipLabel}
            size="small"
            variant="outlined"
            color={settlement.sourceType === 'CREDIT_MEMO' ? 'info' : 'default'}
          />
        </Stack>
        {reference && (
          <Typography variant="caption" color="text.secondary">
            Ref: {reference}
          </Typography>
        )}
      </Box>
      <Typography variant="body2">
        {formatCurrencyValue(settlement.amount)}
      </Typography>
    </Stack>
  );
}
